import { MESSAGE_IMAGE_DURATION_ENUM, THREE_MONTHS } from '../constants/constants';

class ImageDuration {
  value: number;
  txtEnum: string;
  text: string;
  constructor() {
    this.value = THREE_MONTHS;
    this.txtEnum = 'ThreeMonth';
    this.text = 'Three Months';
  }

  static getImageDurationFromEnum(txtEnum: string): ImageDuration {
    const obj = Object.values(MESSAGE_IMAGE_DURATION_ENUM).find(i => i.txtEnum === txtEnum);

    return obj || new ImageDuration();
  }
}

export default ImageDuration;
